<button class="dayButton"
        [title]="getButtonTitle(currentDate | hisDate: tooltipDateFormat, day.events[0]?.description )">
    <div class="dayCell" [ngClass]="determineCssClass()">
        @if (day && day.events.length > 1) {
        <div class="displayInlineBlock markerMultipleEventTriangle"></div>
        }


        <span [ngClass]="day.isToday ? currentDay.css : ''"></span>
        <span [ngClass]="day.isSelected ? selectedDay.css : ''"></span>

        <span class="dayContent">
            @if (day && day.events.length > 0 && (day.dayAttributes.length === 0 ||
            !day.dayAttributes[0]!.mustBeDisplayed)) {
            <!-- INFO: Inhalt der Zelle, wenn mindestens ein Event vorhanden ist -->
            {{ gridCalendarUtils.getText( day.events[0]!.abbreviation ) }}
            }

            @if (day && day.dayAttributes.length > 0 && (day.events.length === 0 ||
            day.dayAttributes[0]!.mustBeDisplayed)) {
            <!-- INFO: Inhalt der Zelle, wenn mindestens ein Attribut und kein Event vorhanden ist oder es ist ein Attribut vorhanden,
        welches zwingend im Kalender dargestellt werden und somit eventuell vorhandene Events überlagern soll -->
            {{ gridCalendarUtils.getText( day.dayAttributes[0]!.abbreviation ) }}
            }
        </span>
    </div>
</button>

<p-overlayPanel #dayoverlay [showCloseIcon]="true" [dismissable]="true">
    <ng-template pTemplate="content">
        <!-- INFO: Inhalt des Popups -->
        <div class="dayoverlay">
            <div class="overlayContent">
                <div class="overlayContentButton">
                    <button (click)="selectDay(true)" class="button_highlighted overlayContentButton"
                            [title]="'cs.sys.hisng.gridcalendar.button.text.timeinterval.from' | hisUi">
                        {{'cs.sys.hisng.gridcalendar.button.text.timeinterval.from' | hisUi}}
                    </button>
                    <button (click)="selectDay(false)" class="button_highlighted overlayContentButton"
                            [title]="'cs.sys.hisng.gridcalendar.button.text.timeinterval.to' | hisUi">
                        {{'cs.sys.hisng.gridcalendar.button.text.timeinterval.to' | hisUi}}
                    </button>
                </div>
                <hr>
                <div class="overlayContentAttributes">
                    @if (getAllDayAttributes().length > 0) {
                    @for (attribute of getAllDayAttributes(); track attribute; let isLast = $last) {
                    <span>
                        {{ gridCalendarUtils.getText( attribute.description ) }}@if (!isLast) {
                        <span> • </span>
                        }
                    </span>
                    }
                    <hr>
                    }
                </div>
                <div class="overlayContentEvents">
                    @if (day && day.events.length > 0) {
                    {{ 'cs.sys.hisng.gridcalendar.events.heading' | hisUi }}
                    <ul>
                        @for (event of day.events; track event) {
                        <li>{{ gridCalendarUtils.getText( event.description ) }}</li>
                        }
                    </ul>
                    } @else {
                    <span>{{ 'cs.sys.hisng.gridcalendar.events.noEvents' | hisUi }}</span>
                    }
                    <ng-template #noEvents>
                        <span>{{ 'cs.sys.hisng.gridcalendar.events.noEvents' | hisUi }}</span>
                    </ng-template>
                </div>
            </div>

            <div class="overlayDay">
                <div class="overlayDayTop">
                    <span class="overlayDayBottomDayOfWeek">{{ day.dayOfWeek | hisUi }}</span>
                </div>
                <div class="overlayDayBottom">
                    <div class="overlayDayBottomElement">
                        <span class="overlayDayBottomMonth">{{ monthOfYear | hisUi }}</span>
                    </div>
                    <div class="overlayDayBottomElement">
                        <span class="overlayDayBottomDay">{{ day.dayId }}</span>
                    </div>
                    <div class="overlayDayBottomElement">
                        <span class="overlayDayBottomYear">{{ year }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>